import { query, onSnapshot, where, QuerySnapshot, DocumentData } from 'firebase/firestore'
import { Record } from '@/models/Record'
import {
  getRecord,
  recordsColl
} from '@/firebase-firestore'
import {
  endOfDay
} from 'date-fns'
import { RecordDoc } from '@/types'

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    registerRunningSubscriptions: null,
    registerRunningSubscriptionsListener: null,
    registerUnpaidSubscriptions: null,
    registerUnpaidSubscriptionsListener: null
  },
  mutations: {
    setRegisterRunningSubscriptions (state: any, arr: []) {
      state.registerRunningSubscriptions = arr
    },
    setRegisterRunningSubscriptionsListener (state: any, listener: number) {
      state.registerRunningSubscriptionsListener = listener
    },
    setRegisterUnpaidSubscriptions (state: any, arr: []) {
      state.registerUnpaidSubscriptions = arr
    },
    setRegisterUnpaidSubscriptionsListener (state: any, listener: number) {
      state.registerUnpaidSubscriptionsListener = listener
    }
  },
  getters: {
    isRegisterSubscriptionsReady: (state: any, getters: any, rootState: any) => {
      return Array.isArray(state.registerRunningSubscriptions) &&
        Array.isArray(state.registerUnpaidSubscriptions) &&
        Array.isArray(rootState.products.products)
    },
    registerSubscriptions: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return getters.isRegisterSubscriptionsReady
        ? [
          ...state.registerRunningSubscriptions,
          ...state.registerUnpaidSubscriptions
        ]
          .map((row: RecordDoc) => new Record({
            ...row,
            product: rootGetters['products/getProduct'](row.productId)
          }))
        : []
    },
    unpaidSubscriptions: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return getters.isRegisterSubscriptionsReady
        ? state.registerUnpaidSubscriptions
          .map((row: RecordDoc) => new Record({
            ...row,
            product: rootGetters['products/getProduct'](row.productId)
          }))
        : []
    }
  },
  actions: {
    releaseRegisterSubscriptions ({ state, dispatch }: { state:any, dispatch:any }) {
      if (state.registerRunningSubscriptionsListener) {
        dispatch('releaseRegisterRunningSubscriptions')
      }
      if (state.registerUnpaidSubscriptionsListener) {
        dispatch('releaseRegisterUnpaidSubscriptions')
      }
    },
    getRegisterSubscriptions ({ dispatch }: { dispatch:any }, date = new Date()) {
      dispatch('getRegisterRunningSubscriptions', date)
      dispatch('getRegisterUnpaidSubscriptions', date)
    },
    releaseRegisterRunningSubscriptions ({ commit, state }: { state:any, commit:any }) {
      if (state.registerRunningSubscriptionsListener) {
        state.registerRunningSubscriptionsListener()
        commit('setRegisterRunningSubscriptionsListener', null)
        commit('setRegisterRunningSubscriptions', null)
        console.warn('Removed listener for register running subscriptions')
      }
    },
    getRegisterRunningSubscriptions ({ commit, dispatch, state }: { state:any, dispatch:any, commit: any }, date = new Date()) {
      if (state.registerRunningSubscriptionsListener) {
        dispatch('releaseRegisterRunningSubscriptions')
      }
      const q = query(
        recordsColl,
        where('categorieId', '==', 'subscriptions'),
        where('dateEnd', '>=', endOfDay(date))
      )
      const listener = onSnapshot(q, { includeMetadataChanges: true }, async (snapshot: QuerySnapshot) => {
        console.time('getRegisterRunningSubscriptions.onSnapshot')
        const recordsIds: string[] = []
        snapshot.forEach((doc: DocumentData) => {
          const recordId = doc.id
          if (!recordsIds.includes(recordId)) {
            recordsIds.push(recordId)
          }
        })
        const promises = recordsIds
          .map(id => getRecord(id))
        const records = await Promise.all(promises)
        commit('setRegisterRunningSubscriptions', records
          .filter(Boolean)
        )
        console.timeEnd('getRegisterRunningSubscriptions.onSnapshot')
      })
      commit('setRegisterRunningSubscriptionsListener', listener)
    },
    releaseRegisterUnpaidSubscriptions ({ commit, state }: { state:any, commit: any }) {
      if (state.registerUnpaidSubscriptionsListener) {
        state.registerUnpaidSubscriptionsListener()
        commit('setRegisterUnpaidSubscriptionsListener', null)
        commit('setRegisterUnpaidSubscriptions', null)
        console.warn('Removed listener for register unpaid subscriptions')
      }
    },
    getRegisterUnpaidSubscriptions ({ commit, dispatch, state }: { state:any, dispatch:any, commit: any }, date = new Date()) {
      if (state.registerUnpaidSubscriptionsListener) {
        dispatch('releaseRegisterUnpaidSubscriptions')
      }
      const q = query(
        recordsColl,
        where('categorieId', '==', 'subscriptions'),
        where('dateEnd', '<', endOfDay(date)),
        where('isPaid', '==', false)
      )
      const listener = onSnapshot(q, { includeMetadataChanges: true }, async (snapshot: QuerySnapshot) => {
        console.time('getRegisterUnpaidSubscriptions.onSnapshot')
        const recordsIds: string[] = []
        snapshot.forEach((doc: DocumentData) => {
          const recordId = doc.id
          if (!recordsIds.includes(recordId)) {
            recordsIds.push(recordId)
          }
        })
        const promises = recordsIds
          .map(id => getRecord(id))
        const records = await Promise.all(promises)
        commit('setRegisterUnpaidSubscriptions', records
          .filter(Boolean)
        )
        console.timeEnd('getRegisterUnpaidSubscriptions.onSnapshot')
      })
      commit('setRegisterUnpaidSubscriptionsListener', listener)
    }
  }
}
